import React, { Fragment, useMemo, useState } from 'react'
// import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from '@headlessui/react'
import { countries, CountryType } from '../constants/countries'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from '@headlessui/react'
import { ChevronDown } from 'lucide-react'

interface CountryDropdownProps {
	onChange: (val: any) => void
	value: any
}

const CountryDropdown: React.FC<CountryDropdownProps> = ({
	onChange,
	value,
}) => {
	const [countryFlag, setCountryFlag] = useState('GH')
	const memoizedCountries = useMemo(() => countries, [])

	return (
		// <></>
		<Listbox
		    onChange={(e) => {
		        onChange(e)
		      setCountryFlag(e.code)
		    }}
		    value={value}
			disabled
		  >
		    <div className='relative h-full'>
		      <ListboxButton
		        className={`h-full outline-none  md:text-sm text-xs w-fit `}
		      >
		        <div className='flex items-center justify-between '>
		          <span className='inset-y-0 left-0 flex items-center text-primary'>
		            <img
		              loading='lazy'
		              height={40}
		              width={20}
		              src={`https://flagcdn.com/w20/${countryFlag.toLowerCase()}.png`}
		              alt=''
		              className='object-contain '
		            />
		          </span>
		          <span className={`block text-left truncate pl-2 pr-1 ${value ? '' : 'text-[#9ca3af]'}`}>
		          {value?.phone || memoizedCountries[0]?.phone}
		          </span>
		          <ChevronDown size={12} />
		        </div>
		      </ListboxButton>
		      <Transition
		        as={Fragment}
		        leave='transition ease-in duration-100'
		        leaveFrom='opacity-100'
		        leaveTo='opacity-0'
		      >
		        <ListboxOptions className='absolute z-20 py-1 mt-1 overflow-auto overflow-x-hidden text-xs bg-white rounded-md shadow-lg max-h-60 focus:outline-none sm:md:text-sm'>
		          {memoizedCountries.map((country: CountryType) => (
		            <ListboxOption
		              key={country.code}
		              className={({selected,  }) =>
		                `relative select-none py-2 pl-10 pr-4 cursor-pointer ${
		                  selected ? 'text-primary bg-gray-100' : 'text-gray-900'
		                }`
		              }
		              value={country}
		            >
		              <>
		                <span
		                  className={`block truncate ${country.phone === value?.value ? 'font-medium' : 'font-normal'}`}
		                >
		                  +{country.phone}
		                </span>
		                <span className='absolute inset-y-0 left-0 flex items-center pl-3 text-primary'>
		                  <img
		                    loading='lazy'
		                    height={20}
		                    width={20}
		                    src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
		                    alt=''
		                  />
		                </span>
		              </>
		            </ListboxOption>
		          ))}
		        </ListboxOptions>
		      </Transition>
		    </div>
		  </Listbox>
	)
}

export default CountryDropdown
